import React, { Component } from "react";
import { invokeApig } from '../../libs/awsLib';

import ReactTable from 'react-table';
import 'react-table/react-table.css';
import CustomerActions from './CustomerActions';

export default class ListCustomers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            customers: [],
            refresh: false
        };
    }
    async componentDidMount() {
        try {
        	const results = await this.customers();
        	this.setState({ customers: results });
        } catch (e) {
        	alert(e);
        }
        this.setState({ isLoading: false });
    }

    customers() {
        return invokeApig({
            path: "/customer/find",
            method: "POST",
            body: {
                "page": 0,
                "size": 10
            }
        });
    }
    handleAlertSuccess = (message) => {
      this.props.onAlertSuccess(message);
      this.setState({ isLoading: true });
      this.componentDidMount();
    }
    handleAlertError = (message) => {
      this.props.onAlertError(message);
    }
    render(){
        const columns = [
        	{ Header: 'Nombre', accessor: 'name' },
        	{ Header: 'Id Documento', accessor: 'documentId' },
            { Header: 'Fecha creación', accessor: 'creationDate' },
            { Header: 'Estado', accessor: 'status' },
        	{ Header: 'Acciones', accessor: '', filterable: false, Cell: row =>
    			<div>
    				<CustomerActions {...this.props} customerId={row.original.id} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
				</div>
            }];

        if (this.state.refresh) {
        	this.componentDidMount();
        }
        return(
            <ReactTable
            	loading={this.state.isLoading}
                data={this.state.customers.results}
                columns={columns}
                defaultPageSize={10}
                pageSizeOptions={[5,10,20,50,100]}
                filterable
                previousText = 'Anterior'
                nextText = 'Siguiente'
                loadingText = 'Listando...'
                noDataText = 'No hay datos'
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/customer/ListCustomers.js